<template>
    <div class="w-full p-10 ">
        <v-card dark :loading="loading" rounded="xl" color="black" tile>
            <v-card-title class="justify-center pa-0 pb-4 ">
                <h4 class=" !text-2xl font-Inter font-semibold !text-center" :class="`${routeLink}_fortext`">Update Profile</h4>
            </v-card-title>
            <v-form @submit.prevent="saveSettings()" ref="form" v-model="valid" lazy-validation class="font-Inter">
                <v-text-field dark v-model="data.age" :counter="10" :rules="nameRules" label="Your Age" required />

                <v-text-field dark v-model="data.location" :counter="10" :rules="nameRules" label=" Your Location"
                    required />

                <v-select dark flat attach v-model="data.education" :counter="10" :rules="nameRules"
                    :class="`${routeLink}_v-select`" :color="colorAsRoute" :item-color="colorAsRoute"
                    :item-text="colorAsRoute" label=" Your Education" :items="educations" required />

                <v-text-field dark v-model="data.job" :counter="25" :rules="nameRules" label=" Your Job" required />

                <p style="color: white">Age Range</p>

                <v-range-slider v-model="partner_age_range" :max="max" :min="min" dark hide-details class="align-center"
                    :color="colorAsRoute">
                    <template v-slot:prepend>
                        <v-text-field :value="partner_age_range[0]" :background-color="colorAsRoute" solo dense
                            class="pt-0 mt-0" hide-details single-line type="number" style="width: 65px"
                            @change="$set(partner_age_range, 0, $event)">
                        </v-text-field>
                    </template>
                    <template v-slot:append>
                        <v-text-field solo dense :value="partner_age_range[1]" :background-color="colorAsRoute"
                            class="pt-0 mt-0" hide-details single-line type="number" style="width: 65px"
                            @change="$set(partner_age_range, 1, $event)">
                        </v-text-field>
                    </template>
                </v-range-slider>

                <v-select v-model="data.interest" :class="`${routeLink}_v-select v-hobbies`" close-icon="mdi-check"
                    :item-color="colorAsRoute" :items="getInterests" item-value="id" item-text="title" flat dark
                     attach chips deletable-chips  label="Select Hobbies" multiple :rules="hobbiesRule"
                    class="my-6 hobbies_chip">
                   </v-select>

                <v-textarea class="pt-0 my-5" dark counter label="BIO" :rules="nameRules" v-model="data.about" :rows="4"  />

                <v-file-input dark v-model="image" accept="image/png, image/jpeg, image/bmp , image/webp"
                    placeholder="Upload Profile Image" prepend-icon="mdi-camera" label="Profile Picture" outlined
                    :color="colorAsRoute" class="pt-5 " :class="`${routeLink}_ccolor`">
                    <template v-slot:selection="{ text }">
                        <v-chip small label :color="`${colorAsRoute}`">
                            {{ text }}
                        </v-chip>
                    </template>
                </v-file-input>

                <section class="text-center filter-switch">
                    <v-file-input dark v-model="images" accept="image/png, image/jpeg, image/bmp,  image/webp" counter
                        prepend-icon="mdi-camera" label="Upload Gallery Image" multiple outlined class="pt-5"
                        :class="`${routeLink}_ccolor`" chips show-size>
                        <template v-slot:selection="{ text }">
                            <v-chip small label :color="`${colorAsRoute}`">
                                {{ text }}
                            </v-chip>
                        </template>
                    </v-file-input>
                </section>

                <div class="flex">
                    <v-btn type="submit" rounded :loading="loading" dark :class="`${routeLink}_color`" class="mb-5 py-3 px-5 !text-black !text-sm">Update</v-btn>
                </div>
            </v-form>
        </v-card>
    </div>

</template>

<script>
import axios from "axios";
import { CometChat } from "@cometchat-pro/chat";


export default {
    name: "ProfileSetting",
    data() {
        return {
            // rules: [
            //   (v) =>
            //     !!v || v.size < 20000000 || "Avatar size should be less than 2 MB!",
            // ],
            nameRules: [(value) => !!value || "This field is required!"],
            galleryRule: [(value) => !!value || "Gallery images are required!"],
            hobbiesRule: [(value) => !!value.length || "Hobbies are required!"],
            min: 18,
            max: 70,
            partner_age_range: [20, 30],
            checkbox: true,
            tab: null,
            items: [
                "Volunteering and community involvement",
                "Writing",
                "Blogging",
                "Podcasting",
                "Marketing",
                "Photography",
                "Learning languages",
                "Travel",
                "Sports",
                "Yoga",
                "Dance",
                "Art",
                "Reading",
                "Making music",
                "Listening to music",
            ],
            avatar: undefined,
            educations: ["Highschool", "Bachelors", "Masters", "PhD"],
            text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
            age: undefined,
            location: undefined,
            education: undefined,
            job: undefined,
            hobbies: undefined,
            about: undefined,
            images: [],
            image: [],
            valid: false,
            data: {},
            loading: false,
            interests: [],

        };
    },
    computed: {
        getInterests() {
            return this.$store.getters.interests;
        },
        colorAsRoute() {
            if (this.routeLink == 'straight') {
                return '#a07a1d'
            }
            else if (this.routeLink == 'gay') {
                return '#88c3fa'
            }
            else if (this.routeLink == 'lesbian') {
                return '#9e2eec'
            }
        }
    },
    methods: {
        updateAvatar() {
            let authKey = process.env.VUE_APP_COMET_CHAT_APP_AUTH_KEY;
            let uid = this.$store.getters.getCometUUID;
            let avatar = this.$store.getters.StateUser.data.image


            var user = new CometChat.User(uid);

            user.setAvatar(avatar);

            CometChat.updateUser(user, authKey).then(
                user => {
                    console.log("user updated", user);
                }, error => {
                    console.log("error", error);
                }
            )
        },
        getAgeRange() {
            const agerangeSet = this.data.partner_age_range = `${this.partner_age_range[0]} to ${this.partner_age_range[1]}`
        },
        async getPersonalData() {
            try {
                this.loading = true;
                const resp = await axios({
                    method: "get",
                    url: "profiles",
                });
                this.data = resp.data.data;
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },


        async saveSettings() {
            this.$refs.form.validate();
            this.getAgeRange()

            const data = new FormData()
            data.append('age', this.data.age);
            data.append('education', this.data.education);
            data.append('location', this.data.location);
            data.append('job', this.data.job);
            data.append('partner_age_range', this.data.partner_age_range);
            data.append('about', this.data.about);
            if (this.image != '') {
                const image = []
                image.push(this.image)
                data.append("image", image[0], image[0].name);
            }
            if (this.images.length > 0) {
                for (let file of this.images) {
                    data.append("images[]", file, file.name);
                }
            }
            if (this.data.interest != undefined) {
                for (let interest of this.data.interest) {
                    data.append("interest[]", interest);
                }
            }

            try {
                this.loading = true;
                const resp = await axios({
                    method: "post",
                    url: "update-profile",
                    data: data,
                });
                this.$store.commit("setUser", resp.data);
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
                this.updateAvatar();

            }
        },

    },
    created() {
        this.getPersonalData();
        this.$store.dispatch('getInterests');

    },
};
</script>

<style scoped>
.v-select:deep(.v-list) {
    background-color: #111 !important;
}

.straight_fortext {
    /* background: rgb(177, 145, 65); */
    background: linear-gradient(335deg,
            rgb(136 97 0) 0%,
            rgb(255 223 153) 53%,
            rgb(130 93 0 / 97%) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.gay_fortext {
    /* background: rgb(177, 145, 65); */
    background: linear-gradient(357deg,
            rgba(0, 240, 255, 1) 55%,
            rgba(0, 156, 255, 1) 75%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.lesbian_fortext {
    /* background: rgb(177, 145, 65); */
    background: linear-gradient(208deg,
            rgba(126, 0, 157, 0.9416141456582633) 2%,
            rgba(161, 51, 246, 1) 45%,
            rgba(157, 0, 176, 0.9668242296918768) 96%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.straight_v-select:deep(.v-list-item__title) {
    color: #ae8c39;
}

.straight_v-select:deep(.v-chip) {
    background-color: #ae8c39 !important;
}

.gay_v-select:deep(.v-list-item__title) {
    color: #88c3fa;
}

.gay_v-select:deep(.v-chip) {
    background-color: #88c3fa !important;
}

.lesbian_v-select:deep(.v-list-item__title) {
    color: #9e2eec;
}

.lesbian_v-select:deep(.v-chip) {
    background-color: #9e2eec !important;
}

.gay_ccolor:deep(.mdi-camera::before) {
    color: #88c3fa !important;
}

.lesbian_ccolor:deep(.mdi-camera::before) {
    color: #9e2eec !important;
}

.straight_ccolor:deep(.mdi-camera::before) {
    color: #ae8c39 !important;
}
.v-hobbies:deep(.v-chip__close){
    color: black;
}
.v-hobbies:deep(.v-chip){
    color: black;
    margin: 10px 6px;
}

.straight_color {
    /*background: linear-gradient(146deg, #dba83b, #d4b577 22%, #ae8935 30%, #a27c2b 70%, #d4b374 80%, #a87a2c);*/
    background: rgb(177, 145, 65);
    background: linear-gradient(345deg,
        rgb(97 69 0) 0%,
        rgba(202, 174, 112, 1) 53%,
        rgb(90 64 0 / 97%) 100%);
  }
  .lesbian_color {
    background: rgb(126, 0, 157);
    background: linear-gradient(208deg,
        rgba(126, 0, 157, 0.9416141456582633) 2%,
        rgba(161, 51, 246, 1) 45%,
        rgba(157, 0, 176, 0.9668242296918768) 96%);
  }
  
  .gay_color {
    background: rgb(0, 240, 255);
    background: linear-gradient(39deg,
        rgba(0, 240, 255, 1) 0%,
        rgba(0, 156, 255, 1) 100%);
  }
  
</style>
